<div class="wrap">
  <div class="content">
    <h4>{{clubInfos?.nom}}</h4>
    <p>{{clubInfos?.adresse}}</p>
    <p> CP {{clubInfos?.codE_POSTAL}} </p>
  </div>
  <div class="contact">
    <div class="web" *ngIf="clubInfos?.url">
      <a [href]="clubInfos?.url">
        <fa-icon [icon]="faGlobe"></fa-icon>
      </a>
    </div>

    <div class="phone">
      <a href="tel:{{clubInfos?.telephone}}" class="phone">
        <fa-icon [icon]="faPhone"></fa-icon>
      </a>
    </div>
    <div class="mail">
      <a href="mailto:{{clubInfos?.email}}" class="phone">
        <fa-icon [icon]="faEnvelope"></fa-icon>
      </a>
    </div>
  </div>
  <div class="btn_action"><button (click)="back()">retour</button></div>
</div>